import { AbsgArrayHelper } from '@absg/angular-common';
import { IStatusProvider } from '@absg/angular-components';
import { PatientLite } from '@absg/api-party';
import { FormularyType, Position, TransferInfo } from '@absg/nim-client-shared';

export class TransferLandingViewModel extends TransferInfo implements IStatusProvider {
  position: Position;
  binCount: number;
  itemCount?: number;
  groupIndex?: number;
  isRequester: boolean;
  cancelAnnexRequestCreatedUser: string;
  annexRequestCreatedUser: string;
  showSubstitutedItem?: boolean;
  isCancelledAnnexRequest: boolean;
  isAnnexStationRequester: boolean;
  positionName: string;
  checkItemAssigned: boolean;
  getFormattedDate: string;
  getFormattedDateTime: string;
  isStatusTransferOutandAnnexRequest: boolean;
  getStationName: string;
  getClinicName: string;
  isPreferredNdc: boolean;
  getTransferQtyInInvWithUOM: string;
  isStatusTransferIn: boolean;
  patientInfo?: PatientLite;
  patientOwnedItemTypeName?: string;
  isItem505b2 = false;

  transferIcon: string;
  transferClass: string;
  transferIconText: string;

  isUnassignedStatus(): boolean {
    return AbsgArrayHelper.isNil(this.position?.storagePosition);
  }

  isDiscontinuedStatus(): boolean {
    if (!AbsgArrayHelper.isNil(this.position) && !AbsgArrayHelper.isNil(this.position.products[0]) && !AbsgArrayHelper.isNil(this.position.products[0].detail)) {
      return this.position.products[0].detail.isDiscontinued;
    } else {
      return false;
    }
  }

  isReturnedStatus(): boolean {
    return false;
  }

  isWastedStatus(): boolean {
    return false;
  }

  isPracticeStatus(): boolean {
    if (!AbsgArrayHelper.isNil(this.position) && !AbsgArrayHelper.isNil(this.position.products[0]) && !AbsgArrayHelper.isNil(this.position.products[0].detail)) {
      return this.position.products[0].detail.formularyTypeId === FormularyType.PracticeOwnedItem;
    } else {
      return false;
    }
  }

  isInsufficientQuantityStatus(): boolean {
    return false;
  }

  isFormularyUnAssignedStatus(): boolean {
    return false;
  }

  isPracticeUnAssignedStatus(): boolean {
    return false;
  }

  isBuyInStatus(): boolean {
    return this.position?.isBuyInStatus();
  }
  is340BStatus(): boolean {
    return this.position?.is340BStatus();
  }
  isPatientOwnedStatus(): boolean {
    return !AbsgArrayHelper.isNil(this.patientInfo?.patientId);
  }

  getPatientId(): number {
    return !AbsgArrayHelper.isNil(this.position) && !AbsgArrayHelper.isNil(this.position.patientInfo)
      && !AbsgArrayHelper.isNil(this.position.patientInfo.patientId) ? this.position.patientInfo.patientId : null;
  }

  getPatientOwnedItemTypeId(): number {
    return !AbsgArrayHelper.isNil(this.position) && !AbsgArrayHelper.isNil(this.position.patientOwnedItemTypeId) ? this.position.patientOwnedItemTypeId : null;
  }

  isPracticeFavorite(): boolean {
    return this.position.isItemPracticeFavorite();
  }

  isItemRefrigerated(): boolean {
    return this.position.isItemRefrigerated();
  }

  isFluVaccineStatus(): boolean {
    return false;
  }
  // TODO(Feature- 248862) this will be set based on future stories by dev
  isItem505b2Status(): boolean {
    return this.isItem505b2;
  }
}
